import React, { useMemo, useState, type FC } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import { Button } from "../../../../components/shared";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import BrazePayloadModal from "../Series/BrazePayloadModal";

type Props = {
  seriesId: string;
};

/**
 * Per-row "⋯" menu on series rows in the campaigns list. Today the only
 * action is opening the Braze payload modal (BONENG-1006).
 */
const SeriesRowActions: FC<Props> = ({ seriesId }) => {
  const [isPayloadOpen, setIsPayloadOpen] = useState(false);

  const menuItems = useMemo<MenuProps["items"]>(
    () => [
      {
        key: "braze-payload",
        label: AppStrings.PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_BUTTON,
      },
    ],
    [],
  );

  return (
    // The whole row navigates to the series detail on click — keep menu
    // and modal interactions from bubbling into that navigation.
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    <div onClick={(event) => event.stopPropagation()}>
      <Dropdown
        menu={{
          items: menuItems,
          onClick: ({ key }) => {
            if (key === "braze-payload") setIsPayloadOpen(true);
          },
        }}
        trigger={["click"]}
      >
        <Button
          intent="neutral"
          variant="ghost"
          iconLeft={<MoreOutlined />}
          aria-label={AppStrings.PAM_DYNAMIC_BONUS_SERIES_ACTIONS_LABEL}
          data-testid={`series-actions-${seriesId}`}
        />
      </Dropdown>

      {isPayloadOpen && (
        <BrazePayloadModal
          open
          seriesId={seriesId}
          onClose={() => setIsPayloadOpen(false)}
        />
      )}
    </div>
  );
};

export default SeriesRowActions;
